import Helmet from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { Button } from 'react-bootstrap';

import { getDashboards, exportCsv } from './DashboardsActions';

import throttle from '../../util/throttle';

import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';
import DashboardActivities from './components/DashboardAcivities';

import downloadIcon from '../../assets/img/download.svg';
import peopleIcon from '../../assets/img/people.svg';

// Import Style
import './Dashboards.scss';

export class Dashboards extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      filter: 'all',
      sort: '-createdDate',
      search: '',
      page: 1,
      boards: [],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        },
      ],
      sortCreatedDate: [
        {
          name: 'Created date: newest first',
          value: '-createdDate'
        },
        {
          name: 'Created date: oldest first',
          value: 'createdDate'
        }
      ],
      sortUpdatedDate: [
        {
          name: 'Updated date: newest first',
          value: '-updatedDate'
        },
        {
          name: 'Updated date: oldest first',
          value: 'updatedDate'
        }
      ],
      sortAccessedDate: [
        {
          name: 'Accessed date: newest first',
          value: '-accessedDate'
        },
        {
          name: 'Accessed date: oldest first',
          value: 'accessedDate'
        }
      ],
    };

    this.getDashboardsThrottled = throttle(this.getDashboards, 500, this);
    this.exportCsvThrottled = throttle(this.exportCsv, 500, this);
  }

  componentDidMount() {
    this.getDashboards();
  }

 getDashboards = () => {
    const { search, sort, sortByName, page } = this.state;
    let { id } = this.props.routeParams;
    if (!id) {
      id = this.props.user._id;
    }
    this.props.getDashboards({ search, sort, page, id });
  };

  applySort = sort => {
    this.setState({ sort, page: 1 }, this.getDashboards);
  };

  getUserId = () =>{
    let { id } = this.props.routeParams;
    if (!id) {
      id = this.props.user._id;
    }
    return id;
  }
  getDashboards = () => {
    const { search, sort, sortByName, page } = this.state;
    let { id } = this.props.routeParams;
    if (!id) {
      id = this.props.user._id;
    }
    this.props.getDashboards({ search, sort, page, id });
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1 }, this.getDashboardsThrottled);
  };

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getDashboards);
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  handleClick = (id) => {
    this.props.router.push(`/permissions/${id}`);
  }

  exportCsv = () => {
    const { filter, sort, search } = this.state;
    this.props.exportCsv({ filter, sort, search, page: 'all' });
  };

  handleExport = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    ev.target.blur();
    this.exportCsvThrottled();
  };

  render() {
    const { isLoading } = this.props;
    return [
      <React.Fragment>
        <Header key="1" title="" showHome={true} />,
        <div key="2" id="create-account" className='bg_dashboard'>
          <Helmet title="Dashboards" />
          <div className='dashboard_container'>
            <div className="action-btn-list">
              <Link className="btn btn-primary" to="/users">
                <img src={peopleIcon} alt=""/>
                See users
              </Link>
              <Button variant='secondary' onClick={this.handleExport}>
                <img src={downloadIcon} alt=""/>
                Export
              </Button>
              
            </div>
            <DashboardActivities userId={this.getUserId()} actions ></DashboardActivities>
          </div>
        </div>
        {isLoading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    exportCsv: opt => dispatch(exportCsv(opt)),
    getDashboards: opt => dispatch(getDashboards(opt))
  };
};

const mapStateToProps = state => {
  return {
    dashboards: state.boards.boards,
    isLoading: state.boards.loading,
    page: state.boards.page,
    total: state.boards.total,
    user: state.auth.user,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboards));
